import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useProfileStore } from "@/modules/settings/stores/useProfileStore";
/**
 * Single frontend source of truth for capability gating. Reads the capability set the BFF
 * computed on the user-profile payload. Fails safe: every capability is denied until the
 * profile has loaded. The backend independently enforces the same rights (403).
 */
export function usePermissions() {
    const { t } = useI18n();
    const profileStore = useProfileStore();
    const permissions = computed(() => profileStore.profile?.permissions ?? []);
    const can = (capability) => permissions.value.includes(capability);
    const isReady = computed(() => !!profileStore.profile);
    const canEditOphub = computed(() => can("ophub.edit"));
    const canManageUsers = computed(() => can("accessmanager.manage-users"));
    const canAdminOpink = computed(() => can("opink.admin"));
    const disabledTooltip = computed(() => t("common.permissions.noEditRights"));
    return { can, isReady, canEditOphub, canManageUsers, canAdminOpink, disabledTooltip };
}
